(function(e){
 e.closest = e.closest || function(css){
   var node = this;

   while (node) {
      if ('matches' in node && node.matches(css)) return node;
      else node = node.parentElement;
   }
   return null;
 }
})(Element.prototype);



// WEBPACK FOOTER //
// ./lib/closestPolyfill.js